import type { OilViscosityParameters } from "../../d";

// returns mu_o cP
export function deadOilViscosityCalculator(params: OilViscosityParameters): {
  deadOilViscosity: number;
  a: number;
} {
  const { temperatureF, oilAPI } = params;
  // Q96: =(10.313*LOG10(D4))-36.447
  const a = 10.313 * Math.log10(temperatureF) - 36.447;

  // Q98: =((3.141*10**10)/(D4**3.444))*(LOG10(D7)**Q96)
  const deadOilViscosity =
    ((3.141 * 10 ** 10) / temperatureF ** 3.444) * Math.log10(oilAPI) ** a;
  return {
    deadOilViscosity,
    a
  };
}
